import React, { useState, useEffect } from "react";

import { Link, NavLink, useNavigate } from "react-router-dom";

// import logo from "../assets/icon/celdon-logo.png";
import logo from "../assets/images/celdon-logo.png";
import axios from "axios";
import brandimg from "../assets/images/brand-image.png";
import frame from "../assets/images/display-frame.png";
import framecat from "../assets/images/framecat.png";
import shutdown from "../assets/images/shutdown.png";
import gallery from "../assets/images/gallery.png";
import planning from "../assets/images/planning.png";
import planslist from "../assets/images/planslist.png";
import shortlogo from "../assets/icon/icon_celdon.png";
import dashboard from '../assets/images/dashboard.png'
import videosection from '../assets/images/videoicon.png'
import info from "../assets/images/info.png"


const Sidebaar = ({ content }) => {
  const [isCollapsed, setIsCollapsed] = useState(
    localStorage.getItem("isCollapsed") === "true"
  );
  const navigate = useNavigate();

  const handleToggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
    localStorage.setItem("isCollapsed", isCollapsed ? "false" : "true");
  };

  useEffect(() => {
    checkCollapse();
  }, []);

  const checkCollapse = () => {
    if (localStorage.getItem("isCollapsed") === "true") {
      setIsCollapsed(true);
    }
  };

  //   useEffect(() => {
  //     if (!localStorage.getItem("token")) {
  //       navigate("/");
  //     }
  //   }, []);

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      // Handle specific error codes or situations here

      if (error.response && error.response.status === 403) {
        // Handle 403 error without logging it
        // navigate("/login");

        navigate("/");
      }

      return Promise.reject(error);
    }
  );

  const handlelogout = () => {
    // Clear cookies
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
    });

    localStorage.clear();
  };

  const menuData = [
    { path: '/dash', icon: <img src={dashboard} className="img-fluid" alt="" />, label: 'Dashboard' },
    { path: '/user', icon: <i className="fa-solid fa-users"></i>, label: 'Users' },
    { path: '/category', icon: <i className="fa-solid fa-list"></i>, label: 'Category' },
    { path: '/slider', icon: <img src={gallery} className="img-fluid" alt="" />, label: 'Slider' },
    { path: '/brand', icon: <img src={brandimg} className="img-fluid" alt="" />, label: 'Brand' },
    { path: '/brandmodel', icon: <i className="fa-solid fa-b"></i>, label: 'Brand Model' },
    { path: '/framecategory', icon: <img src={framecat} className="img-fluid" alt="" />, label: 'Frame Category' },
    { path: '/frames', icon: <img src={frame} className="img-fluid" alt="" />, label: 'Frame' },
    { path: '/planning', icon: <img src={planning} className="img-fluid" alt="" />, label: 'Plans' },
    { path: '/planslist', icon: <img src={planslist} className="img-fluid" alt="" />, label: 'Plans List' },
    { path: '/videosection', icon: <img src={videosection} className="img-fluid" alt="" />, label: 'Video' },
    { path: '/aboutus', icon: <i class="fa-solid fa-circle-info"></i>, label: 'Policy' },
    { path: '/contact', icon: <i class="fa-regular fa-address-card"></i>, label: 'Contact Us' },
    { path: '/complain', icon: <i class="fa-solid fa-file"></i>, label: 'Complain' },
    { path: '/', icon: <img src={shutdown} className="img-fluid" alt="" />, label: 'Logout', isLogout: true },
  ];

  return (
    <div className="w-100 d-flex">
      <div className={`sidebarContainer ${isCollapsed ? "collapsed" : ""}`}>
        <div className="w-100 h-100 position-relative">
          <div className="sidebar-header  flex justify-center">
            <Link
              className="btn text-dark bg-white"
              id="closeSidebar"
              onClick={handleToggleSidebar}
            >
              {isCollapsed ? (
                <i class="fa-solid fa-xmark fs-5"></i>
              ) : (
                <i class="fa-solid fa-bars fs-5"></i>
              )}
            </Link>
            <Link className="d-md-none d-block desktoplogo ">
              <img
                src={logo}
                className="img-fluid mobile_fullname_logo"
                alt=""
              />
            </Link>
            <Link className="d-none d-md-block ">
              {isCollapsed ? (
                <img
                  src={shortlogo}
                  alt=""
                  className="img-fluid beat_logo mt-0"
                  style={{ width: "80px" }}
                />
              ) : (
                <img src={logo} alt="" className="img-fluid beat_logo" />
              )}

              {/* <img src={logo} className="img-fluid fullname_logo" alt="" /> */}
            </Link>
          </div>
          <div className="sidebar-content" id="Sidebar_nav">
            {/* <ul className="list-unstyled">

              <li>
                <NavLink
                  to={"/dash"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <img src={dashboard} className="img-fluid" alt="" />
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Dashboard
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/user"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <i class="fa-solid fa-users"></i>
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Users
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/category"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <i class="fa-solid fa-list"></i>
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Category
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/slider"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <img src={gallery} className="img-fluid" alt="" />
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Slider
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/brand"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <img src={brandimg} className="img-fluid" alt="" />
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Brand
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/brandmodel"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <i class="fa-solid fa-b"></i>
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Brand Model
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/framecategory"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <img src={framecat} className="img-fluid" alt="" />
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Frame Category
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/frames"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <img src={frame} className="img-fluid" alt="" />
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Frame
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/planning"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <img src={planning} className="img-fluid" alt="" />
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Plans
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/planslist"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <img src={planslist} className="img-fluid" alt="" />
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Plans List
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/videosection"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <img src={videosection} className="img-fluid" alt="" />
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Video
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/videosection"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                >
                  <span className="icon">
                    <img src={videosection} className="img-fluid" alt="" />
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Video
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={"/"}
                  className="d-flex  align-items-center gap-2 Sidebar_link"
                  onClick={(e) => handlelogout(e)}
                >
                  <span className="icon">
                    <img src={shutdown} alt="" className="img-fluid" />
                  </span>
                  <p
                    className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}
                  >
                    Logout
                  </p>
                </NavLink>
              </li>
            </ul> */}
            <ul className="list-unstyled">
              {menuData.map((item, index) => (
                <li key={index}>
                  <NavLink
                    to={item.path}
                    className="d-flex align-items-center gap-2 Sidebar_link"
                    onClick={(e) => item.isLogout && handlelogout(e)}
                  >
                    <span className="icon">{item.icon}</span>
                    <p className={`tool-tip ${!isCollapsed ? "" : "nonetooltip"}`}>
                      {item.label}
                    </p>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
          <div className="sidebar-footer ">{/* Sidebar footer */}</div>
        </div>
      </div>
      <div className={`mainContainer  ${isCollapsed ? "collapsed" : ""}`}>
        <div className="w-100 h-100">
          <div className="w-100 sticky-top">
            <nav className="w-100 topbarNav nav-bg">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-md-12 col-4">
                    <Link
                      className="btn border-0 shadow-none makeExtend bg-white"
                      onClick={handleToggleSidebar}
                    >
                      {isCollapsed ? (
                        <i class="fa-solid fa-xmark fs-5"></i>
                      ) : (
                        <i class="fa-solid fa-bars fs-5"></i>
                      )}
                    </Link>
                    <div className="mobilelogo">
                      <Link className="d-md-none d-block">
                        <img
                          src={logo}
                          className="img-fluid mobile_fullname_logo"
                          alt=""
                        />
                      </Link>
                      <Link className="d-none d-md-block">
                        <img
                          src={logo}
                          alt=""
                          className="img-fluid beat_logo"
                        />
                        <img
                          src={logo}
                          className="img-fluid fullname_logo"
                          alt=""
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
            <div className="container-fluid" style={{ marginTop: "90px" }}>
              <div className="row gy-3 mt-3">{content}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebaar;
